import { Controller } from "stimulus"
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light-border.css'

const contentKey = 'data-tippy-content'
const templateKey = 'data-tippy-template'

function getContent(el) {
  if (el.hasAttribute(templateKey)) {
    const id = el.getAttribute(templateKey)
    const template = document.getElementById(id)
    return template.innerHTML
  }

  if (el.hasAttribute(contentKey)) {
    return el.getAttribute(contentKey)
  }
}

export default class extends Controller {
  static targets = [ "anchor" ]

  connect() {
    this.tippy = tippy(this.targetElement, {
      triggerTarget: this.element,
      arrow: true,
      allowHTML: true,
      content: () => getContent(this.element)
    })
  }

  disconnect() {
    this.tippy.destroy()
  }

  get targetElement() {
    return this.hasAnchorTarget ? this.anchorTarget : this.element
  }
}
